export const initStateBankFee = (
   Object.assign({
      data : [],
      logo             : '',
      beneficiary_name : '',
      bank             : '',
      branch_office    : '',
      account_number   : '',
      interbank_key    : '',
      oxxo_deposit     : '',
      swift_code       : '',
      actionForm       : false,
      bankDetailFeeId  : ''
   })
);